import React from 'react';
import { motion } from 'framer-motion';
import { XIcon, CheckIcon } from 'lucide-react';
const problems = ['Każdy nowy dział oznacza kolejne notatki, ćwiczenia i sprawdzian.', 'Materiały są rozproszone po folderach i stronach internetowych.', 'Trudne pojęcia wymagają długich wyjaśnień.', 'Planowanie zaczyna się od nowa co tydzień.'];
const solutions = ['Prowadzisz uczniów przez spójną kolejność tematów.', 'Masz wizualne strony teorii oraz gotowe zadania do wydruku.', 'Korzystasz ze sprawdzianów, kluczy i planów zamiast tworzyć je od zera.', 'Dopasowujesz materiały do pracy indywidualnej, grupowej, powtórki lub oceny.'];
export function ProblemSolution() {
  return <section className="w-full px-5 py-14 sm:py-20" data-id="element-277" data-mp="4kohwkn79mos">
      <div className="mx-auto max-w-5xl" data-id="element-278" data-mp="4jvkwbe1mbju">
        <h2 className="mx-auto max-w-2xl text-center font-display text-2xl font-bold leading-tight text-ink sm:text-4xl" data-id="element-279" data-mp="4iu4dre9cwuq">
          Nie musisz już spędzać wieczorów na składaniu lekcji chemii z przypadkowych plików.
        </h2>

        <div className="mt-10 grid gap-5 md:grid-cols-2 md:gap-6" data-id="element-280" data-mp="6s92vxykdtax">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="rounded-2xl border border-rose-100 border-l-4 border-l-rose-300 bg-rose-soft p-6 sm:p-8" data-id="element-281" data-mp="6uvce350mivs">
            <h3 className="mb-5 text-lg font-bold text-ink sm:text-xl" data-id="element-282" data-mp="3k9rtnq8anef0">
              Gdy wszystko tworzysz samodzielnie
            </h3>
            <ul className="space-y-3" data-id="element-283" data-mp="3b7ikb3orhr37">
              {problems.map(item => <li key={item} className="flex items-start gap-3" data-id="element-284" data-mp="3f8cay4tl9jzs">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-rose-100 text-rose-600" data-id="element-285" data-mp="3f8m2vxy72184">
                    <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-286" data-mp="1dgz61frmfc3q" />
                  </span>
                  <span className="text-sm leading-relaxed text-ink/80" data-id="element-287" data-mp="2mdwb32z4ldzf">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.3,
          delay: 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="rounded-2xl border border-chem/20 border-l-4 border-l-chem bg-chem-soft p-6 sm:p-8" data-id="element-288" data-mp="2hdrrh42x834z">
            <h3 className="mb-5 text-lg font-bold text-chem-deep sm:text-xl" data-id="element-289" data-mp="313bz4b79v5bf">
              Z Wizualną Chemią™
            </h3>
            <ul className="space-y-3" data-id="element-290" data-mp="2w9r0cgxuu7b6">
              {solutions.map(item => <li key={item} className="flex items-start gap-3" data-id="element-291" data-mp="2rc7il71y7ceh">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-chem/15 text-chem-deep" data-id="element-292" data-mp="3oswmd6agkoqi">
                    <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-293" data-mp="3k03ggf397acu" />
                  </span>
                  <span className="text-sm leading-relaxed text-ink/80" data-id="element-294" data-mp="3redql3tb74tf">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}